import React from 'react';

const Fake404 = () => {
  return (
    <div className="fake-error" style={{ display: 'block' }}>
      <h1>403 Forbidden</h1>
      <p>VPN or automated traffic detected. Access denied.</p>
    </div>
  );
};

export default Fake404;